import { TenantSignalScreen } from "@src/features/patriot-tools";

export default TenantSignalScreen;
